import { Button, Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import CommentIcon from "@material-ui/icons/Comment";
import type { EditableCallbackParams } from "ag-grid-community";
import { useEffect, useState } from "react";
import { EditWorkOrderModal } from "@/shared/work-orders-modals/components/modal-edit-work-order";
import { useSearchWorkOrderAttachments } from "@/shared/work-orders-modals/components/hooks/useSearchWOAttachaments";
import { ErrorModal } from "@dexteel/mesf-core";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			"& .ag-icon-menu": {
				display: "none",
			},
			"& .ag-checkbox-input-wrapper": {
				margin: "0 10px",
			},
			"& .ag-cell": {
				alignItems: "center",
				padding: "0 !important",
				backgroundColor: "#FFFF !important",
				border: "unset !important",
			},
			"& .ag-header-cell": {
				padding: "0px !important",
				textAlign: "center !important",
				fontSize: 10,
			},
			"& .ag-root-wrapper": {
				minHeight: "100% !important",
				borderRadius: 3,
				paddingBottom: 45,
			},
			"& .ag-cell-wrapper": {
				width: "95%",
				textAlign: "center",
			},
			"& .ag-body-viewport": {
				borderBottom: "2px solid #DDE2EB",
			},
			"& .ag-menu-option": {
				cursor: "pointer",
			},
		},
	}),
);

type Props = {
	params: EditableCallbackParams;
	searchWorkOrders: Function;
};

export const WorkOrderCommentsColumnColumn = ({
	params,
	searchWorkOrders,
}: Props) => {
	const classes = useStyles();
	const [openGridEditDialog, setOpenGridEditDialog] = useState<boolean>(false);
	const [attachmentsList, setAttachmentsList] = useState([]);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<string>("");
	const searchWorkOrderAttachments = useSearchWorkOrderAttachments({
		WorkOrderId: params.data?.WorkOrderId,
		setAttachmentsList,
		setIsLoading,
		setError,
	});
	useEffect(() => {
		if (openGridEditDialog) searchWorkOrderAttachments();
	}, [openGridEditDialog]);

	if (params.data.id !== -1) {
		return (
			<>
				<Grid
					container
					className={classes.root}
					spacing={1}
					style={{ alignItems: "center" }}
				>
					{params.data?.Comments && (
						<Grid item md={12} xs={12}>
							<Button
								onClick={() => setOpenGridEditDialog(true)}
								fullWidth
								color="primary"
								style={{
									textDecoration: "none",
									fontWeight: 500,
									fontSize: "12px",
									borderRadius: "3px",
									marginRight: 8,
								}}
								title={`${(params.data?.Comments).substr(0, 50)}...`}
							>
								<CommentIcon />
							</Button>
						</Grid>
					)}
				</Grid>
				<EditWorkOrderModal
					show={openGridEditDialog}
					data={params.data as any}
					onHide={(shouldUpdate: boolean) => {
						if (shouldUpdate) {
							searchWorkOrders();
						}
						setOpenGridEditDialog(false);
					}}
				/>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	} else return <></>;
};
